import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

function ProfileIncompletePopup() {
  const navigate = useNavigate();
  const closeRef = useRef<HTMLButtonElement>(null);
  const { t } = useLanguage();

  const handleGoToProfile = () => {
    closeRef.current?.click();
    setTimeout(() => navigate("/profil"), 300); // modal kapanma animasyonu
  };

  return (
    <div
      className="modal fade"
      id="profileIncompleteModal"
      tabIndex={-1}
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "360px" }}>
        <div className="modal-content rounded-4 shadow">
          <div className="modal-body px-4 py-4 text-center">
            <button ref={closeRef} className="d-none" data-bs-dismiss="modal" />
            <div className="mb-3">
              <i
                className="bi bi-person-exclamation"
                style={{ fontSize: "3rem", color: "#c20e1a" }}
              ></i>
            </div>

            <h6 className="fw-bold fs-5 mb-2">{t("profileIncomplete.title")}</h6>
            <p className="text-muted small mb-4">{t("profileIncomplete.description")}</p>

            <button
              type="button"
              className="btn btn-danger w-100 rounded-pill py-2 fw-semibold mb-2"
              onClick={handleGoToProfile}
            >
              <i className="bi bi-person-fill me-2"></i>
              {t("profileIncomplete.completeButton")}
            </button>

            <button
              type="button"
              className="btn btn-outline-secondary btn-sm w-100 rounded-pill"
              data-bs-dismiss="modal"
            >
              {t("common.close")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfileIncompletePopup;
